import * as React from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { getImageProps } from "next/image";
import { cn } from "@/lib/utils";
const Avatar = React.forwardRef<React.ElementRef<typeof AvatarPrimitive.Root>, React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>>(({
  className,
  ...props
}, ref) => <AvatarPrimitive.Root ref={ref} className={cn("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", className)} {...props} />);
Avatar.displayName = AvatarPrimitive.Root.displayName;
const AvatarImage = React.forwardRef<React.ElementRef<typeof AvatarPrimitive.Image>, React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>>(({
  className,
  ...props
}, ref) => <AvatarPrimitive.Image ref={ref} className={cn("aspect-square h-full w-full", className)} {...props} />);
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
export function NextAvatarImage({
  src,
  alt,
  size = "md",
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Image> & {
  size?: "sm" | "md" | "lg" | "xl";
}) {
  // Map size props to actual pixel dimensions
  const sizeMapping = {
    sm: 32,
    // 8 * 4 = 32px
    md: 48,
    // 12 * 4 = 48px
    lg: 80,
    // 20 * 4 = 80px
    xl: 128 // 32 * 4 = 128px
  };
  const pixelSize = sizeMapping[size] || 48; // Default to md size

  const {
    props: imageProps
  } = getImageProps({
    src: src || "",
    alt: alt || "",
    width: pixelSize,
    height: pixelSize,
    sizes: `${pixelSize}px`,
    quality: 80
  });
  return <AvatarPrimitive.Image {...props} {...imageProps} data-sentry-element="unknown" data-sentry-component="NextAvatarImage" data-sentry-source-file="avatar.tsx" />;
}
const AvatarFallback = React.forwardRef<React.ElementRef<typeof AvatarPrimitive.Fallback>, React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback>>(({
  className,
  ...props
}, ref) => <AvatarPrimitive.Fallback ref={ref} className={cn("flex h-full w-full items-center justify-center rounded-full bg-muted", className)} {...props} />);
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;
export { Avatar, AvatarFallback, AvatarImage };